<template>
  <div class="container">
    <div class="left-wrapper">
      <img :src="systemInfo?.systemLogo || 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/common/default-logo.png'" alt="" class="logo">
      <div class="name">{{ systemInfo?.systemName || '大数据服务平台' }}</div>
    </div>
    <div class="nav">
      <router-link
        v-for="(route, index) in routeList"
        :key="index"
        :to="route.path"
        class="tab"
        :class="path.includes(route.path) ? 'is-active' : ''">
        {{ route.name }}
      </router-link>
    </div>
    <div class="operation">
      <el-image
        class="user-img"
        src="https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/common/header-right.png"
        fit="contain">
      </el-image>
      <div class="hover-box">
        <div class="box_item" @click="handleLogout">退出登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { logoutApi, getSystemInfoApi } from 'src/api/common'
export default {
  name: 'DataScreenHeader',
  data () {
    return {
      routeList: [
        { path: '/home', name: '首页' },
        { path: '/template', name: '大屏模板' },
        { path: '/screen', name: '数据大屏' },
        { path: '/system', name: '系统管理' },
      ],
      hoverBoxShow: false,
    }
  },
  computed: {
    ...mapGetters(['systemInfo']),
    path () {
      return this.$route.path
    },
  },
  async created () {
    if (!this.systemInfo) {
      try {
        const res = await getSystemInfoApi()
        this.$store.commit('system/SET_SYSTEM_INFO', { ...res })
      } catch (e) {
        // this.$error(e)
      }
    }
  },
  methods: {
    async handleLogout () {
      try {
        await logoutApi()
        this.$router.push({ path: '/login' })
      } catch (e) {
        this.$error(e)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 60px;
  position: relative;
  background: #191919;
  color: #FFFFFF;
  display: inline-flex;
  justify-content: space-between;
  .left-wrapper{
    width: 400px;
    margin-left: 40px;
    display: flex;
    align-items: center;
    .logo{
      height: 32px;
      object-fit: cover;
      margin-right: 5px;
    }
    .name{
      font-size: 18px;
    }
  }
  .nav {
    flex: 1;
    display: inline-flex;
    justify-content: center;
    .tab {
      color: #FFFFFF;
      display: inline-block;
      width: 112px;
      height: 24px;
      line-height: 60px;
      text-align: center;
      vertical-align: middle;
    }
  }

}
.is-active {
  font-weight: bold;
  background-size: cover;
  position: relative;
  &::before{
    position: absolute;
    content: "";
    width: 14px;
    height: 3px;
    background: #FFFFFF;
    border-radius: 2px;
    left: 45%;
    bottom: -29px;
  }
}
.operation{
  width: 400px;
  display: inline-flex;
  flex-direction: row-reverse;
  margin-right: 40px;
  align-items: center;
  position: relative;
  &:hover{
    .hover-box{
      display: block;
    }
  }
  .user-img{
    width: 36px;
    height: 36px;
    cursor: pointer;
  }
  .hover-box{
    position: absolute;
    width: 80px;
    height: 40px;
    top: 55px;
    right: -20px;
    box-shadow: 0px 3px 12px rgba(209, 218, 233, 0.8);
    border-radius: 8px 8px;
    background: #FFF;
    padding: 10px 0;
    text-align: center;
    z-index: 100;
    display: none;
    .box_item{
      cursor: pointer;
      color: #999;
      width: 100%;
      &:hover{
        color: #258AFF;
        font-weight: bold;
      }
    }
  }
}
</style>
